export const lettersAndNumbersOnlyNoSpacesStartRegex = new RegExp(
  /^[A-Za-z0-9 ]*[A-Za-z0-9][A-Za-z0-9 ]*$/
);
export const lettersOnlyNoSpacesStartRegex = new RegExp(/^[A-Za-z ]*[A-Za-z][A-Za-z ]*$/);
export const phoneNumberRegex = new RegExp(
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
);
export const postodeRegex =
  /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2})$/;
//export const websiteRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#()?&//=]*)/);
export const websiteRegex = new RegExp(
  /[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#()?&//=]*)/
);

export const vehicleRegNumberUKRegex = new RegExp(/(^[A-Z]{2}[0-9]{2}[A-Z]{3}$)/);
// DVLA UK LICENCE PLATES
// /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/

export const ibanUKRegex = new RegExp(/^[A-Z]{2}(?:[ ]?[0-9]){18,20}$/);

export const sortCodeRegex = new RegExp(/^\d{6}$/);

export const vatRegex = new RegExp(/^[A-Za-z0-9]{9,12}$/);
